import * as React from "react";
import FileList from "./FileList";
import {
  PublicAssetFrontendApi$AssetComponentDto,
} from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import useAssetFileBrowser from "./useAssetFileBrowser";
import { FrontendFilesApi as FrontendFilesApiGeneric } from "@/custolink-transpiled_by_server/bc.asset_files.api_generic";
import GetPath from "@/custolink-logic/api/GetPath";
import useUiContext from "@/custolink-hooks/useUiContext";
import { AssetViewDetails } from "@/custolink-views/asset_frontend/asset_view/useAssetViewFacade";

const FileComponent = (p: {
  assetViewDetails: AssetViewDetails;
  assetComponent: PublicAssetFrontendApi$AssetComponentDto;
  /** Opens the page's Account drawer (sign in or switch account). */
  onSignIn: () => void;
}) => {
  const uic = useUiContext();
  const assetFileBrowser = useAssetFileBrowser(
    p.assetViewDetails,
    p.assetComponent.id,
  );

  return (
    <FileList
      fileBrowser={assetFileBrowser}
      layout={"grid"}
      getDownloadLinkHref={(id) => {
        const params = p.assetViewDetails.urlParamsForRequests
        return FrontendFilesApiGeneric.downloadFile(
          GetPath,
          uic._orgId,
          params.viewId,
          params.viewValue,
          params.assetId,
          id,
        );
      }}
      onSignIn={p.onSignIn}
    />
  );
};

export default FileComponent;
